<section class="consultas-section">
    <div class="container">
        <div class="consultas-row">
            <div class="consultas-illustration" aria-hidden="true"></div>
            <div class="consultas-card">
                <div class="consultas-head">
                    <h3>Mis consultas legales</h3>
                    <span class="badge-count" *ngIf="!loading && items.length > 0">{{ items.length }}</span>
                    <span class="skeleton skeleton-badge" *ngIf="loading"></span>
                </div>
                <div class="consultas-empty" *ngIf="!loading && items.length === 0">
                    Aún no hay ningúna consulta
                </div>
                <div class="consultas-list" *ngIf="loading">
                    <div class="consulta-item consulta-item--skeleton" *ngFor="let s of skeletonSlots">
                        <div class="consulta-body">
                            <span class="skeleton skeleton-line skeleton-line--title"></span>
                            <div class="consulta-meta">
                                <span class="skeleton skeleton-line skeleton-line--meta"></span>
                                <span class="skeleton skeleton-line skeleton-line--meta"></span>
                            </div>
                        </div>
                        <div class="consulta-actions">
                            <span class="skeleton skeleton-btn"></span>
                        </div>
                    </div>
                </div>
                <div class="consultas-list" *ngIf="!loading">
                    <div class="consulta-item" *ngFor="let consulta of items">
                        <div class="consulta-body">
                            <h4>{{ consulta.titulo }}</h4>
                            <div class="consulta-meta">
                                <span class="meta-fecha">
                                    <span class="meta-label">Fecha de apertura:</span>
                                    <span class="meta-value">{{ consulta.fechaApertura }}</span>
                                </span>
                                <span class="meta-abogado">
                                    <span class="meta-label">Abogado:</span>
                                    <span class="meta-value">{{ consulta.tramitador }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="consulta-actions">
                            <button type="button" class="btn-ver-consulta" (click)="irDetalle(consulta)">Ver consulta</button>
                        </div>
                    </div>
                </div>
                <a class="consultas-link" *ngIf="!loading && items.length > 0" (click)="irA('/queries')">Ver todas mis consultas</a>
            </div>
        </div>
    </div>
</section>

<app-modal-dialog [show]="detailOpen"
                  title="Resolución de la consulta"
                  [width]="624"
                  (closed)="closeDetail()">
    <div class="lq-detail" *ngIf="selectedConsulta">
        <h4 class="lq-detail-title">{{ selectedConsulta.titulo }}</h4>
        <p class="lq-detail-desc">{{ selectedConsulta.detalle }}</p>
    </div>
</app-modal-dialog>
